import {
  ATTESTATION_DESER,
  ATTESTATION_TOKEN_DESER,
  Attestation,
  AttestationToken,
} from "../../tastyworks/attestation"
import type HttpClient from "../../tastyworks/http"
import {
  parseSingleResponse,
  type SingleResponse,
} from "../../tastyworks/response"

export class AttestationService {
  private readonly httpClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.httpClient = baseHttpClient.nested("attestations")
  }

  readonly createToken = async (): Promise<
    SingleResponse<AttestationToken>
  > => {
    const helper = await this.httpClient.postJson("tokens", {})
    return parseSingleResponse(
      helper,
      ATTESTATION_TOKEN_DESER.toParser(AttestationToken)
    )
  }

  readonly create = async ({
    reasonCode,
    token,
  }: {
    reasonCode: string
    token: string
  }): Promise<SingleResponse<Attestation>> => {
    const helper = await this.httpClient.postJson("", {
      "reason-code": reasonCode,
      token,
    })
    return parseSingleResponse(helper, ATTESTATION_DESER.toParser(Attestation))
  }
}
